import * as React from "react"
import type { SVGProps } from "react"
const SvgAppStore = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M4 11a1 1 0 0 1-.71-.29A1 1 0 0 1 3 10V4q0-.42.29-.71.29-.3.71-.29h6q.42 0 .71.29.3.29.29.71v6q0 .42-.29.71-.29.3-.71.29zm10 0a1 1 0 0 1-.71-.29A1 1 0 0 1 13 10V4q0-.42.29-.71.29-.3.71-.29h6q.42 0 .71.29.3.29.29.71v6q0 .42-.29.71-.29.3-.71.29zM4 21a1 1 0 0 1-.71-.29A1 1 0 0 1 3 20v-6q0-.42.29-.71.29-.3.71-.29h6q.42 0 .71.29.3.29.29.71v6q0 .42-.29.71-.29.3-.71.29zm13 0a1 1 0 0 1-.71-.29A1 1 0 0 1 16 20v-2h-2.03a1 1 0 0 1-.7-.29A1 1 0 0 1 13 17q0-.42.29-.71.29-.3.71-.29h2v-2.03q0-.42.29-.7A1 1 0 0 1 17 13q.42 0 .71.29.3.29.29.71v2h2.02q.43 0 .7.29A1 1 0 0 1 21 17q0 .42-.29.71-.29.3-.71.29h-2v2.02q0 .43-.29.7A1 1 0 0 1 17 21M15 5v4h4V5zM5 5v4h4V5zm0 10v4h4v-4z" />
  </svg>
)
export default SvgAppStore
